module.exports = __webpack_public_path__ + "static/img/manual-11.b219405.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/en/manual-11.png
// module id = 0gog
// module chunks = 4